import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import LinearProgress from "@material-ui/core/LinearProgress";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import VideocamOffIcon from "@material-ui/icons/VideocamOff";

import withStyles from "@material-ui/styles/withStyles";

import { Storage } from "aws-amplify";
import axios from "axios";
import _ from "lodash";

//containers
import AdminWrapper from "../containers/AdminWrapper";
import ContentWrapper from "../containers/ContentWrapper";
//actions
import * as dialogActions from "../redux/actions/dialogactions";
//contants
import * as shotTypes from "../redux/constants/ShotActionTypes";
//services
import shotService from "../services/shotService";
import ConfirmationDialog from "./Dialogs/ConfirmationDialog";

const styles = theme => ({
  icon: {
    color: "rgba(255, 255, 255, 0.54)"
  },
  dangerButton: {
    color: "#C0392B",
    borderColor: "rgb(192, 57, 43,0.5)",
    "&:hover": {
      borderColor: "#c0392b",
      backgroundColor: "rgb(192, 57, 43,0.1)"
    }
  },
  warningButton: {
    color: "#F39C12",
    borderColor: "rgb(243, 156, 18,0.5)",
    "&:hover": {
      backgroundColor: "rgb(243, 156, 18,0.1)",
      borderColor: "#f39c12"
    }
  }
});

class ViewShot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shot: {
        data: {},
        fetching: true,
        failed: false
      },
      photoList: {
        data: [],
        fetching: true,
        failed: false,
        fetched: false
      },
      featuredImage: {
        data: {
          src: null
        },
        fetching: true,
        failed: false,
        fetched: false
      },
      selectedPhoto: null
    };
  }

  async componentDidUpdate(prevProps) {
    if (this.props.confirmDialog === false && prevProps.confirmDialog) {
      if (this.props.confirmChoice) {
        switch (this.props.confirmAction) {
          case shotTypes.SHOT_DELETE:
            console.log("delete shot!");
            //code the side delete shott side-effect here
            try {
              let shot = _.assign({}, this.state.shot, { fetching: true });
              this.setState({
                shot
              });
              await shotService.deleteOneShot(this.props.match.params.id, {
                params: {
                  scene: this.props.router.location.search.scene
                }
              });
              this.props.history.push("/shots/" + this.state.shot.data.type);
            } catch (err) {
              console.log(err);
            }
            break;
          default:
            break;
        }
      }
    }
  }

  async componentDidMount() {
    let { data } = await shotService.getOneShot(this.props.match.params.id, {
      params: {
        scene: this.props.router.location.search.scene
      }
    });
    console.log(data);
    let shot = Object.assign({}, this.state.shot, {
      data: data,
      fetching: false,
      failed: false,
      fetched: true
    });
    let photoList = this.state.photoList;
    this.setState({
      shot
    });

    let featuredImage = await this.getFeaturedImage(`photo/${this.props.match.params.id}/featured.png`);
    featuredImage = { src: featuredImage };
    featuredImage = Object.assign({}, this.state.featuredImage, {
      data: featuredImage,
      fetching: false,
      fetched: true
    });

    console.log("featured", featuredImage);
    this.setState({ featuredImage });

    let photo = await Storage.list("photo/" + this.props.match.params.id + "/sample-images");

    photo = photo.map(photo => {
      let key = photo.key;
      let firstRemove = key.substring(key.indexOf("/") + 1);
      let name = firstRemove.substring(firstRemove.indexOf("/") + 1);

      return {
        ...photo,
        name
      };
    });

    //get the public links
    let photoLinks = await this.getPublicLinks(photo);
    photoList = Object.assign({}, this.state.photoList, {
      fetching: false,
      data: photoLinks
    });
    this.setState({
      photoList
    });
  }

  getPublicLinks = async list => {
    let urlList = await Promise.all(
      list.map(item => {
        return Storage.get(item.key);
      })
    );
    let finalList = list.map((item, index) => {
      console.log(urlList[index]);
      return {
        ...item,
        src: urlList[index]
      };
    });
    return finalList;
  };

  handleClick = event => {
    this.setState({ selectedPhoto: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ selectedPhoto: null });
  };

  styling = {
    typography: {
      paddingLeft: 25
    },
    section: {
      margin: "20px 0"
    },
    sectionContainers: {
      padding: "24px",
      marginTop: 20
    },
    title: {
      marginBottom: 15
    }
  };

  deleteShot = () => {
    this.props.dialogActions.openConfirmDialog(
      "Are you sure?",
      "You are about to delete this shot. Do you really want to proceed this action?",
      shotTypes.SHOT_DELETE
    );
  };

  editShot = () => {
    //edit shot does not need any confirmation
    //we only need confirmation if the user is about to save or go back
    //go to edit page
    let id = this.props.match.params.id;
    let scene = this.props.location.search.scene;
    this.props.history.push("/shots/edit/" + id + "?scene=" + scene);
  };

  getFeaturedImage = async path => {
    try {
      let featuredImage = await Storage.get(path);
      await axios.get(featuredImage);
      console.log(`featured`, featuredImage);
      return featuredImage;
    } catch (err) {
      console.log(err.message);
      if (err.message === "Request failed with status code 404") {
        return null;
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { selectedPhoto } = this.state;
    const open = Boolean(selectedPhoto);

    let featuredImage = null;
    if (this.state.featuredImage.data.src) {
      featuredImage = (
        <div
          style={{
            textAlign: "center",
            flex: 1,
            padding: "20px 0"
          }}
        >
          <img src={this.state.featuredImage.data.src} style={{ maxWidth: "600px" }} />
        </div>
      );
    } else {
      featuredImage = (
        <div
          style={{
            textAlign: "center",
            flex: 1,
            padding: "20px 0"
          }}
        >
          <AddPhotoAlternateIcon style={{ fontSize: 120 }} color="primary" />
          <Typography variant="h6" style={{ color: "rgba(0,0,0,0.5)" }}>
            No featured image
          </Typography>
        </div>
      );
    }
    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title="View Shot" hasPadding>
          <div>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 30
                }}
              >
                <Button variant="outlined" color="primary" onClick={this.props.history.goBack}>
                  Back
                </Button>
                <div>
                  <Button variant="outlined" color="primary" style={{ margin: "0 5px" }} className={classes.dangerButton} onClick={this.deleteShot}>
                    Delete Shot
                  </Button>
                  <Button variant="outlined" color="primary" style={{ margin: "0 5px" }} className={classes.warningButton} onClick={this.editShot}>
                    Edit Shot
                  </Button>
                </div>
              </div>
              <Typography variant="subtitle1">Shot Details</Typography>
              {this.state.shot.fetching || this.state.photoList.fetching || this.state.featuredImage.fetching ? (
                <LinearProgress color="primary" style={{ height: 2 }} />
              ) : null}
              {this.state.shot.fetched ? (
                <Paper style={this.styling.sectionContainers}>
                  <Grid container>
                    <Grid item xs={12} md={12} sm={12}>
                      <Typography variant="h6">Description</Typography>
                      <Typography variant="subtitle1" gutterBottom style={this.styling.typography}>
                        {this.state.shot.data.description}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sm={6}>
                      <Typography variant="h6">Scene</Typography>
                      <Typography variant="subtitle1" gutterBottom style={this.styling.typography}>
                        {this.state.shot.data.scene}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sm={6}>
                      <Typography variant="h6">Location</Typography>
                      <Typography variant="subtitle1" gutterBottom style={this.styling.typography}>
                        {this.state.shot.data.location}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sm={6}>
                      <Typography variant="h6">Angle</Typography>
                      <Typography variant="subtitle1" gutterBottom style={this.styling.typography}>
                        {this.state.shot.data.angle}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sm={6}>
                      <Typography variant="h6">Framing</Typography>
                      <Typography variant="subtitle1" gutterBottom style={this.styling.typography}>
                        {this.state.shot.data.framing}
                      </Typography>
                    </Grid>
                    {this.state.shot.type === "video" ? (
                      <Grid item xs={12} md={4} sm={6}>
                        <Typography variant="h6">Camera Movement</Typography>
                        <Typography variant="subtitle1" gutterBottom style={this.styling.typography}>
                          {this.state.shot.data.camera}
                        </Typography>
                      </Grid>
                    ) : null}
                    <Grid item xs={12} md={4} sm={6}>
                      <Typography variant="h6">Shot Type</Typography>
                      <Typography variant="subtitle1" gutterBottom style={this.styling.typography}>
                        {this.state.shot.data.type}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              ) : null}
            </div>

            {!this.state.fetching && this.state.shot.data.type === "photo" && (
              <div style={{ marginTop: 50 }}>
                <Typography variant="subtitle1">Featured Image</Typography>
                {this.state.featuredImage.fetching ? null : <div style={{ marginTop: 20 }}>{featuredImage}</div>}
              </div>
            )}

            {!this.state.fetching && this.state.shot.data.type === "photo" && (
              <div style={{ marginTop: 50 }}>
                <Typography variant="subtitle1">Sample Images</Typography>
                {this.state.photoList.fetching ? null : (
                  <div style={{ marginTop: 20 }}>
                    <GridList cellHeight={280} cols={5}>
                      {this.state.photoList.data.length > 0 ? (
                        this.state.photoList.data.map(photo => (
                          <GridListTile key={photo.key}>
                            <img src={photo.src} alt={photo} />
                            {/* <GridListTileBar
                        title={photo.name}
                        actionIcon={
                          <>
                            <IconButton
                              className={classes.icon}
                              aria-label="More"
                              aria-owns={open ? 'long-menu' : undefined}
                              aria-haspopup="true"
                              onClick={this.handleClick}
                            >
                              <MoreVertIcon />
                            </IconButton>
                            
                          </>
                        }
                      /> */}
                          </GridListTile>
                        ))
                      ) : (
                        <div
                          style={{
                            textAlign: "center",
                            flex: 1,
                            padding: "20px 0"
                          }}
                        >
                          <Typography variant="h6" style={{ color: "rgba(0,0,0,0.5)" }}>
                            No sample images
                          </Typography>
                        </div>
                      )}
                    </GridList>
                  </div>
                )}
              </div>
            )}
            {!this.state.fetching && this.state.shot.data.type === "video" && (
              <div style={{ width: "100%", marginBottom: 20 }}>
                {this.state.shot.data.video_url ? (
                  <div
                    style={{
                      width: "100%",
                      paddingTop: "56.25%",
                      position: "relative"
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        right: 0,
                        left: 0
                      }}
                    >
                      <iframe
                        width="100%"
                        height="100%"
                        src={this.state.shot.data.video_url}
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      fontSize: "60px",
                      flexDirection: "column",
                      padding: "60px",
                      alignItems: "center"
                    }}
                  >
                    <VideocamOffIcon fontSize="inherit" color="primary" />
                    <Typography color="textSecondary">No video</Typography>
                  </div>
                )}
              </div>
            )}

            {/* <div style={{ marginTop: 50 }}>
            <Typography variant="subtitle1">
              Guidelines
            </Typography>
            <Divider />
            {
              this.state.videoList.fetching ? 
                <LinearProgress 
                  color="primary"
                  style={{ height: 2 }} 
                />
              :
                <div style={this.styling.sectionContainers}>
                {                
                  this.state.videoList.data.length !== 0 ? 
                    <Grid container alignItems="center" justify="center" spacing={16} style={this.styling.section}>
                      <Grid item md={8} xs={12}>
                        <Player src={this.state.videoList[0].src}>
                          <BigPlayButton position="center" />
                        </Player>
                      </Grid>
                    </Grid>
                  :
                  <Typography variant="subtitle1"  style={this.styling.title}>
                    No video guidelines added.
                  </Typography>
                }
                </div>
            }
          </div>  */}
          </div>
          <Menu
            id="long-menu"
            anchorEl={selectedPhoto}
            open={open}
            onClose={this.handleClose}
            PaperProps={{
              style: {
                width: 100
              }
            }}
          >
            <MenuItem onClick={this.handleClose}>Delete</MenuItem>
          </Menu>
          <ConfirmationDialog />
        </ContentWrapper>
      </AdminWrapper>
    );
  }
}

const StyledViewShot = withStyles(styles)(ViewShot);

const mapStateToProps = state => {
  return {
    confirmDialog: state.dialog.confirm.open,
    confirmAction: state.dialog.confirm.action,
    confirmChoice: state.dialog.confirm.confirmed,
    router: state.router
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StyledViewShot);
